import type { GetTokenFn, TokenProvider, PowerSyncCredentials } from './types';

/**
 * Creates a PowerSync-compatible token provider from a generic token getter.
 *
 * @param getToken - Function that retrieves the authentication token
 * @param endpoint - PowerSync endpoint URL (required)
 * @returns TokenProvider function for PowerSync client configuration
 *
 * @example
 * ```ts
 * const tokenProvider = makeTokenProvider(
 *   () => getIdToken(),
 *   'https://powersync.example.com'
 * );
 * ```
 */
export function makeTokenProvider(getToken: GetTokenFn, endpoint: string): TokenProvider {
  return async (): Promise<PowerSyncCredentials> => {
    const token = await getToken();
    return { token, endpoint };
  };
}
